import { render, staticRenderFns } from "./aipage.vue?vue&type=template&id=757bbfa4&scoped=true"
import script from "./aipage.vue?vue&type=script&lang=js"
export * from "./aipage.vue?vue&type=script&lang=js"
import style0 from "./aipage.vue?vue&type=style&index=0&id=757bbfa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757bbfa4",
  null
  
)

export default component.exports